import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import DefaultButton from './../../../components/DefaultButton';
import TextInput from './../../../components/TextInput';
import IconCancel from './../../../icons/cancel.svg';
import ModelDetails from './ModelDetails';
import { translate } from "react-i18next";
import IconDelete from './../../../icons/delete.svg';
import { modalInstance } from './../Content';
import {
    SELECTED_MODEL_INDEX,
} from '../../../types/model';
import {
    setSelectedModelIndex,
    deleteModel,
    loadModelsDetails,
} from './../../../actions/model';
import Spinner from './../../../components/Spinner';

const ModelTabTitle = styled.h3`
    margin: 0 5px;
`;

const MessageWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    >p{
        margin-left: 5px;
        text-align: center;
    }
`;

const ModelContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
`;

const ModelsContainer = styled.div`
    overflow: auto;
    height: 100%;
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    border-top: 1.5px solid #80808033;
`;

const Thumbnail = styled.img` 
    width: 85%;
    min-height: 100px;
    image-rendering: pixelated;
    padding: 2px;
    border-width: 1.5px;
`;

const TitleWrapper = styled.div`
    width: 100%;
    background: linear-gradient(0deg, #263650 0%, #082242 100%);
    color: #ffffff;
    padding: 5px;
    height: 25px;
    display: 'block';
    margin-bottom: 5px;
`;

const ModelListRow = styled.div`
    width: 100%;
    background-color: #ffffff;
    margin: 5px;
    border-radius: 5px;
    width: calc(100% - 10px);
    border: 1px solid #ebebeb;

    input[type='radio'] {
        display: none;
    }

    label {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        :hover {
            .rowTitle{
                border: 1px solid #a7c1d7;
                padding: 6.5px;
            }
        }
        .rowTitle {
            cursor: pointer;
            border: 1px solid #ebebeb;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6.5px;
            >span{
                font-size: 14px;
                font-weight: 600;
            }
        }
        .filename {
            align-self: flex-start;
            margin: 6px;
            width: calc(100% - 45px);
            
            color: #2d2d2d;
            font-size: 14px;
            font-weight: 600;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    
    input[type='radio']:checked+label>.rowTitle {
        border: 1.5px solid ${props => props.borderColor || '#265a9c'};
        box-shadow: 0 1px 3px #0000004d;
        padding: 6px;
    }
`;

const Row = styled.div`
    display: flex;
    margin: 3px 0 10px 0;
    padding: 0;
    align-items: center;
    width: calc(100% - 20px);
    justify-content: space-between;
`;

export class ModelModeContent extends React.Component {
    filterInput = '';
    constructor() {
        super();
        this.state = {
            filterTerm: '',
            selectedModels: [],
        }
    }

    modelChangeHandler(value) {
        const { modelsDetails, setSelectedModelIndex } = this.props;
        const index = modelsDetails.findIndex(model => {
            return model.id === Number(value);
        })
        if (index !== -1)
            setSelectedModelIndex(index);
    }

    toggleModelSelection(model) {
        const { selectedModels } = this.state;
        const selectedModel = selectedModels.find(testedModel => testedModel.id === model.id);
        if (selectedModel) {
            this.setState({
                selectedModels: selectedModels
                    .filter(testedModel => testedModel.id !== selectedModel.id)
            })
        }
        else {
            this.setState({
                selectedModels: selectedModels.concat([model])
            })
        }
    }

    customizeModalWindow() {
        const { axiosInstance, deleteModel, t } = this.props
        const { selectedModels } = this.state;
        const confirmCallback = () => {
            for (let i = 0; i < selectedModels.length; i++) {
                deleteModel(axiosInstance, selectedModels[i].id)
            }
        }
        const config = {
            title: t('Do you really want to delete selected files') + '?',
            content: <p>{t('Do you really want to delete selected files')}?</p>,
            confirmCallback: confirmCallback,
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    render() {
        const { modelsDetails, roles, chosenFlight, t } = this.props;
        const { filterTerm } = this.state;
        if (modelsDetails === null) {
            return <Spinner />
        }
        if (!chosenFlight || modelsDetails.length === 0) {
            return (
                <ModelContentWrapper>
                    <TitleWrapper>
                        <ModelTabTitle>
                            {t('Models')}:
                        </ModelTabTitle>
                    </TitleWrapper>
                    <MessageWrapper>
                        <p>{chosenFlight ? t('No models for chosen mission') : t('No mission selected please select')}</p>
                    </MessageWrapper>
                </ModelContentWrapper>);
        }
        return (
            <ModelContentWrapper>
                <TitleWrapper>
                    <ModelTabTitle>
                        {t('Models')}:
                    </ModelTabTitle>
                </TitleWrapper>

                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                    }}>
                    <TextInput
                        style={{
                            width: 'calc(100% - 14px)',
                            margin: '2px 7px 2px 7px',
                        }}
                        type="text"
                        placeholder={t('Search') + '...'}
                        value={filterTerm}
                        onChange={(event) => this.setState({
                            filterTerm: event.target.value
                        })}
                    />
                    <DefaultButton
                        style={{
                            right: '10px',
                            top: '6px',
                            position: 'absolute',
                        }}
                        visible={filterTerm !== ''}
                        title={t('Clear')}
                        onClick={() => {
                            this.setState({
                                filterTerm: ''
                            })
                        }}>
                        <ReactSVG
                            path={IconCancel}
                            style={{
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                </div>
                <Row
                    style={{
                        justifyContent: 'space-between',
                    }}>
                    <DefaultButton
                        style={{
                            display: 'flex',
                            width: '35px',
                            height: '20px',
                            alignSelf: 'flex-start',
                        }}
                        type='warning'
                        title={t('Delete')}
                        disabled={roles === 'Regular' || this.state.selectedModels.length === 0}
                        onClick={() => {
                            this.customizeModalWindow();
                        }}>
                        <ReactSVG
                            path={IconDelete}
                            style={{
                                fill: '#ffffff',
                                width: '15px',
                                height: '15px',
                            }}
                        />
                    </DefaultButton>
                </Row>
                <ModelsContainer>
                    {modelsDetails
                        .filter(model => {
                            const fileName = model.description;
                            const { filterTerm } = this.state;
                            return fileName.toUpperCase().includes(filterTerm.toUpperCase())
                        })
                        .map(model => {
                            const { selectedModels } = this.state;
                            const { selectedModelIndex } = this.props;
                            const detailsVisible = modelsDetails[selectedModelIndex].id === model.id;
                            const { id } = model;
                            const selected = selectedModels.find(testedModel => testedModel.id === id);
                            return (
                                <ModelListRow key={model.id}>
                                    <input
                                        id={`model_${String(model.id)}_radio`}
                                        type='radio'
                                        name='model'
                                        value={model.id}
                                        checked={detailsVisible ? 'checked' : ''}
                                        onChange={(e) => {
                                            this.modelChangeHandler(e.target.value)
                                        }} />
                                    <label htmlFor={`model_${String(model.id)}_radio`}>
                                        <div className='rowTitle' style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'unset'
                                        }}>
                                            <div className='filename'>
                                                {model.description}
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                                <Thumbnail className='rowTitle'
                                                    src={model.urlThumb}
                                                    alt={t('This thumbnail is not longer available.')}
                                                />
                                            </div>
                                            <ModelDetails
                                                model={model}
                                                visible={detailsVisible}
                                                toggleModelSelection={this.toggleModelSelection.bind(this)}
                                                selected={selected}
                                            />
                                        </div>
                                    </label>
                                </ModelListRow>
                            )
                        })
                    }
                </ModelsContainer>
            </ModelContentWrapper>
        );
    };
};

const mapStateToProps = state => ({
    [SELECTED_MODEL_INDEX]: state.model.get(SELECTED_MODEL_INDEX),
    selectedModelIndex: state.model.get('selectedModelIndex'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    roles: state.auth.get('roles'),
    axiosInstance: state.auth.get('axiosInstance'),
    modelsDetails: state.model.get('models_details'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setSelectedModelIndex,
    deleteModel,
    loadModelsDetails,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ModelModeContent));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/ModelModeContent.jsx